import React from 'react';
import { useAmp } from 'next/amp';
import Head from 'next/head';


export default () => (
  <>
    {useAmp() ? null : (
      <Head>
        <meta key="viewport" name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
      </Head>
    )}
    <Head>
      <link key="poppins" href="https://fonts.googleapis.com/css?family=Poppins:300,400,500,700&display=swap" rel="stylesheet" />
    </Head>
  </>
);
